import { addError, addLoading, getLoading, removeLoadingAndError } from '../core/redux/api/module';
import { hasTrippedBreaker, updateBreaker } from '../core/redux/api/circuitBreaker/module';
import { IAppState } from '../core/redux/IAppState';
import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../core/redux/api/reduxStandardApiAction';
import { apiGetTrainingDocuments } from '../core/redux/api/endpoints';
import { ACTION_TYPE } from '../core/redux/actionType';
import { TrainingDocument } from './trainingDocument';
import { assoc } from '../language/module';


const KEY_ACTION = ACTION_TYPE.LOAD_TRAINING_DOCS_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.LOAD_TRAINING_DOCS_REQUEST,
  ACTION_TYPE.LOAD_TRAINING_DOCS_RESPONSE,
  ACTION_TYPE.LOAD_TRAINING_DOCS_ERROR,
];


export const loadTrainingDocumentsAction = () => makeApiAction(
  {
    method:   'GET',
    endpoint: apiGetTrainingDocuments,
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    types:    ACTIONS as RsaaTypes,
    bailout:  state => !!getLoading(state, KEY_ACTION, KEY_ACTION) || hasTrippedBreaker(state, KEY_ACTION),
  },
);


const reducer: ApiReducer<TrainingDocument[]> = (state, action, error, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, KEY_ACTION, KEY_ACTION, error);
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, KEY_ACTION, KEY_ACTION);

  return assoc('trainingDocuments', payload, noLoadingOrError);
};


export const loadTrainingDocumentsReducer = makeApiReducer<TrainingDocument[]>(ACTIONS, KEY_ACTION, reducer);
